// #region imports

// --- Angular
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

// --- RxJs
import { combineLatest, map } from 'rxjs';

// --- HS Code
import { environment } from '../../../environments/environment';
import { Constants, ParticipantValidationDestinations } from '../../models';
import { OidcService, SurveyBaseService } from '../services';

// #endregion
export const mobileUserGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const oidcService: OidcService = inject(OidcService);
  const router: Router = inject(Router);
  const surveyService: SurveyBaseService = inject(SurveyBaseService);

  return combineLatest([
    oidcService.isMobileUser$,
    surveyService.mostRecentParticipantSurvey()
  ]).pipe(
    map(([isMobileUser, surveyIdentifiers]) => {
      if (!isMobileUser) {
        return true;
      }

      if (!surveyIdentifiers) {
        window.location.href = environment.mobileCallbackUrl;
        return false;
      }

      const manageRespondentsRedirect = localStorage.getItem(Constants.PARTICIPANT_REDIRECT_DESTINATION_KEY);
      if (manageRespondentsRedirect && manageRespondentsRedirect === ParticipantValidationDestinations.managerespondents) {
        return router.createUrlTree(['/dashboard/managerespondents']);
      }

      return router.createUrlTree(['/surveys', { id: surveyIdentifiers.surveyReference }]);
    })
  );
}
